import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    width: '100%',
  },
  titleIconContainer: {
    display: 'flex',
    height: '28px',
    width: '28px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: `${theme.palette.textBackground.main} !important`,
    borderRadius: '4px',
  },
  titleIcon: {
    color: theme.palette.labraText.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 500,
    padding: '0 8px',
    '& .fa': {
      color: theme.palette.labraText.primary,
      textAlign: 'center',
      padding: 0,
      width: '18px',
      height: '20px',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 'normal',
      letterSpacing: '0.15px',
    },
  },
  headingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  headingInnerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  heading: {
    fontSize: '18px',
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
  },
  bold: {
    fontWeight: 500,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  noteContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  offerRecipientV4Container: {
    marginLeft: '2%',
  },
  offerRecipientTableContainer: {
    marginBottom: theme.spacing(2),
  },
}))
